import React from 'react'

import style from './separator.scss'

const Separator: React.FC = () => (
  <div className={style.separator} />
)

export default Separator
